<template>
  <div class="vacation-type-select">
    <vacation-type-swiper class="vacation-type-slider" :class="[filterKey]">
      <template v-if="vacationTypes">
        <div
          class="swiper-slide"
          :data-term="type.term_id"
          v-for="type in vacationTypes"
        >
          <div class="slide-inner-wrap">
            <div
              @click="nextStep()"
              :style="{ 'background-image': 'url(' + type.thumbnail + ')' }"
              class="slide-inner"
            >
              <div class="slide-fade"></div>
              <div class="slide-inside">
                <div class="title smaller">{{ type.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </vacation-type-swiper>
    <next-step-btn></next-step-btn>
  </div>
</template>

<script>
import Vue from "vue";

import VacationTypeSwiper from "./VacationTypeSwiper.vue";
import VacationPlanSlider from "../../components/VacationPlanSlider";
import NextStepBtn from "./NextStepBtn.vue";

export default {
  components: {
    VacationTypeSwiper,
    NextStepBtn
  },
  props: ["vacationTypes", "filterKey"],
  created() {
    this.$parent.selected_filters[
      this.filterKey
    ] = this.vacationTypes[0].term_id;
  },
  methods: {
    nextStep() {
      window.eventBus.$emit("nextStep");
    }
  },
  mounted() {
    let $slider = new VacationPlanSlider(`.${this.filterKey}`);

    Vue.nextTick(() => {
      $slider.swiper.on("slideChange", () => {
        const vacationTypeTerm = $(
          $slider.swiper.slides[$slider.swiper.activeIndex]
        ).data("term");
        window.eventBus.$emit("selectVacationType", {
          key: this.filterKey,
          term: vacationTypeTerm
        });
      });
    });
  }
};
</script>
